import { Badge } from "@/components/ui/badge";
import { useAppData } from "@/contexts/AppDataContext";
import { cn } from "@/lib/utils";

interface PageTitleProps {
  title: string;
  brandScoped?: boolean;
  className?: string;
}

export function PageTitle({ title, brandScoped = false, className }: PageTitleProps) {
  const { brands, selectedBrandId } = useAppData();
  const currentBrand = brands.find((b) => b.id === selectedBrandId) || brands[0];

  return (
    <div className={cn("flex items-center gap-3", className)}>
      <h1 className="text-3xl font-semibold text-foreground">{title}</h1>
      {brandScoped && currentBrand?.name && (
        <Badge variant="secondary">{currentBrand.name}</Badge>
      )}
    </div>
  );
}
